import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import { ReactComponent as RocketIcon } from '../../../assets/svg/utils/rocket-withput-shadow.svg';
import { formatNumbers } from '../../../helpers';
import { useRocketCoins } from '../../../hooks/useRocketCoins';
import Pages from '../../../Router/pages';

function RocketBalance() {
  const { rocketCoins, rocketCoinsPerHour } = useRocketCoins();

  const navigate = useNavigate();

  return (
    <div
      className="
        header-rocket-balance gradient-border before:rounded-8 z-[1]
        relative
        flex justify-center
        h-[33px] w-full max-w-[88px]
        bg-[#3B4AF0]
        rounded-8
        ml-[14px]
        shadow-rocketBalance
      "
      onClick={() => navigate(Pages.dropBank)}
    >
      <div className="absolute top-[-4px] left-0 transform -translate-x-[22px]">
        <BalanceSvg />
      </div>
      <span className="font-Bangers text-base pt-1 leading-[17px] px-2">{parseFloat(rocketCoins.toFixed(3))}</span>
      <div
        className="
          px-2 py-1
          bg-rocketBalanceBg
          absolute
          bottom-[2px]
          left-[50%]
          transform translate-x-[-50%] translate-y-[50%]
          text-[8px] leading-[10px] text-[#B5C4FC] font-bold
          w-max
          rounded-8
          gradient-border header-rockets-per-hour before:rounded-8 z-[1]
          flex gap-[2px]
        "
      >
        <span className="font-Bangers text-[#BCE4FF] font-normal">{formatNumbers(rocketCoinsPerHour, 4)}</span>
        per hour
      </div>
    </div>
  );
}

export default RocketBalance;

const BalanceSvg = memo(() => <RocketIcon className="w-[42px] h-auto" vectorEffect="non-scaling-stroke" style={{ imageRendering: 'crisp-edges' }} />);
BalanceSvg.displayName = 'BalanceSvg';
